import {
  ApiBlueprint,
  createFrontendPlugin,
  FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { PageBlueprint } from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
} from '@backstage/core-compat-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';

import { correlationRouteRef, eventRouteRef } from './routes';
import { eventStatusApiRef } from './api';
import { DefaultApiClient } from '@internal/plugin-eventstatus-common';

const eventStatusPage = PageBlueprint.make({
  name: 'eventstatus',
  params: {
    path: '/eventstatus/:id',
    routeRef: convertLegacyRouteRef(eventRouteRef),
    loader: () =>
      import('./components/EventStatusComponent').then(m =>
        compatWrapper(<m.EventStatusComponent />),
      ),
  },
});

const correlationStatusPage = PageBlueprint.make({
  name: 'correlationstatus',
  params: {
    path: '/correlations/:correlationId',
    routeRef: convertLegacyRouteRef(correlationRouteRef),
    loader: () =>
      import('./components/EventStatusComponent').then(m =>
        compatWrapper(<m.EventStatusComponent />),
      ),
  },
});

const eventStatusApi = ApiBlueprint.make({
  name: 'eventstatus',
  params: defineParams =>
    defineParams({
      api: eventStatusApiRef,
      deps: { fetchApi: fetchApiRef, discoveryApi: discoveryApiRef },
      factory: ({ fetchApi, discoveryApi }) =>
        new DefaultApiClient({ discoveryApi, fetchApi }),
    }),
});

export const eventStatusPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'eventstatus',
  extensions: [eventStatusApi, eventStatusPage, correlationStatusPage],
  routes: convertLegacyRouteRefs({ eventRouteRef }),
});
